export default { sha: 'c7937481729fe4de19fadc5e735b6fa25c5e6df4', buildNumber: 'undefined' }
